import React, { Component } from 'react';

export default class Chapter1 extends Component {
  render() {
    return (
      <div>
        <div className="medium-padding joysetter-header">
          <h6 className="white">Jet Lag Tool Kit</h6>
          <h1 className="white">Chapter 8: Bridging the Gap</h1>
          <p className="white"><b>How to find your joy</b></p>
        </div>
        <div className="toolkit-content">
          <ol >
            <li>Live your life with a focus on the Triad of Purpose: openminded curiosity, drive, and surrender/trust. Just as you would rebalance your investment portfolio, dedicate time each month to reflect on whether or not you are placing too much emphasis on any one aspect of the triad.
            </li>
            <li>Utilize your tool kit of gratitude, continuous learning/growth, and participation through love. Live fully by pursuing never-ending growth and actively participate in the moment in front of you out of a place of love and contribution.
            </li>
            <li>When adversities arise, actively look for the lesson, the gift, or the humor. Get out of your head and into your heart.
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/chapter8.js